import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5a83395e&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=5a83395e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83395e",
  null
  
)

export default component.exports